import React, { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart, addToWishList } from "../../store/actions/action";
import api from "../../api";
import Navbar3 from "../../components/Navbar3/Navbar3";
import Hero4 from "../../components/hero4/hero4";
import About from "../../components/about/about";
import Quote3 from "../../components/quote3/quote3";
import VideoSection from "../../components/VideoSection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import RsvpSectionS3 from "../../components/RsvpSectionS3/RsvpSectionS3";
import Testimonial from "../../components/Testimonial/Testimonial";
import TeamSection from "../../components/TeamSection/TeamSection";
import PricingSection from "../../components/PricingSection/PricingSection";
import FunFact from "../../components/FunFact/FunFact";
import PartnerSection from "../../components/PartnerSection";
import Product from "../../components/Product";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

interface HomePage4Props {
  addToCart: (product: any, qty?: number) => void;
  addToWishList: (product: any) => void;
}

const HomePage4: React.FC<HomePage4Props> = ({ addToCart, addToWishList }) => {
  const productsArray = api();
  const products = productsArray;

  const addToCartProduct = (product: any, qty = 1) => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product: any) => {
    addToWishList(product);
  };

  return (
    <Fragment>
      <Navbar3 hclass="header-style-s4" />
      <Hero4 />
      <About />
      <Quote3 />
      <VideoSection />
      <ServiceSection />
      <ProjectSection />
      <RsvpSectionS3 />
      <Testimonial />
      <TeamSection />
      <PricingSection />
      <FunFact />
      <Product
        addToCartProduct={addToCartProduct}
        addToWishListProduct={addToWishListProduct}
        products={products}
        pClass="pb-0"
      />
      <PartnerSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(HomePage4);
